import { render } from "./CustomerCostCentersView.vue?vue&type=template&id=0c3ce48c&ts=true&lang=pug"
import script from "./CustomerCostCentersView.vue?vue&type=script&lang=ts"
export * from "./CustomerCostCentersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__